// @flow

/**
 * Module dependencies.
 */

import { colors } from 'client/styles';
import { translator } from 'core/utils';
import Content from 'client/components/content';
import Header from 'client/components/header';
import PageContent from 'client/components/core/page-content';
import React from 'react';
import StaticSections from 'client/components/static-sections';

/**
 * `Props` type.
 */

type Props = {
  translate: Function
};

/**
 * `Compliance` component.
 */

const Compliance = ({ translate }: Props): React$Element<*> => {
  const whoWeAreItems = [{
    text: translate('compliance.sections.internationalRegulamentation.text'),
    title: translate('compliance.sections.internationalRegulamentation.title')
  }, {
    text: translate('compliance.sections.transparencyAndSupervision.text'),
    title: translate('compliance.sections.transparencyAndSupervision.title')
  }, {
    text: translate('compliance.sections.consumerAndProtection.text'),
    title: translate('compliance.sections.consumerAndProtection.title')
  }, {
    text: translate('compliance.sections.combatingMoneyLaundering.text'),
    title: translate('compliance.sections.combatingMoneyLaundering.title')
  }];

  return (
    <PageContent background={colors.shadesOfSand2.pampasDarker}>
      <Header
        filename={'about-us-header'}
        title={translate('compliance.title')}
      />

      <Content
        paddingVertical={13}
        pullTop
        separator
      >
        <StaticSections
          items={whoWeAreItems}
          title={translate('compliance.lead')}
        />
      </Content>
    </PageContent>
  );
};

/**
 * Export `Compliance` component.
 */

export default translator()(Compliance);



// WEBPACK FOOTER //
// ../src/client/containers/compliance/index.js